module.exports = __webpack_public_path__ + "background-main.765b7ffd5f084945196f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background-main.jpg
// module id = 900
// module chunks = 3